// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2u9mb","notes":"Notes_notes__3Um8t"};